<template>
  <div class="home">
    <div v-if="loading">Téléchargement...</div>
  </div>
</template>

<script>
import axios from "axios";
import fileDownload from "js-file-download";

export default {
  name: "Download",
  data: () => ({ loading: false }),
  async mounted() {
    this.loading = true;
    try {
      const { data } = await axios({
        method: "get",
        url: `${process.env.VUE_APP_API_URI}/files/${this.$route.params.name}`,
        data: {
          idisa: this.idisa,
        },
        responseType: "arraybuffer",
      });
      fileDownload(data, "attestation.pdf");
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  },
};
</script>
